import React from "react";
import Grievance from "../../Grievance/Components";
import CommonLayout from "../CommonLayout";

const ReportIssue: React.FC = () => {
  return (
    <CommonLayout>
      <Grievance />
    </CommonLayout>
  );
};

export default ReportIssue;
